import { css, keyframes, styled } from 'styled-components';

import { MissionMode } from '@/modules/promotions/helpers/questPromo';

import { device, typography } from '@/styles/helpers';

export const ScMission = styled.div<{
  mode: MissionMode;
  isSpecialMission?: boolean;
}>`
  position: static;
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 0 0 80px;

  @media (${device.mobile}) {
    gap: 4px;
  }

  & .date {
    text-transform: uppercase;
    ${typography['headline3']}
  }

  & .display {
    position: relative;
    width: 80px;
    height: 80px;
    cursor: pointer;

    & .background {
      position: absolute;
      z-index: 1;
    }
    & .foreground {
      position: absolute;
      z-index: 2;
      bottom: 0;
      left: 0;
      transition:
        left 0.3s ease-in,
        bottom 0.3s ease-in,
        transform 0.3s ease-in,
        filter 0.3s ease-in;

      ${({ mode, isSpecialMission }) =>
        mode !== MissionMode.TodayFailed &&
        isSpecialMission &&
        css`
          &:hover {
            filter: drop-shadow(0 0 6px #ffecd5);
          }
        `};

      ${({ mode }) =>
        (
          mode === MissionMode.TodayCompleted ||
            mode === MissionMode.PastCompleted
        ) &&
        css`
          filter: drop-shadow(0 0 3px #ffecd5);
          animation: ${glow} 1s infinite alternate;
        `};
    }
    ${({ mode, isSpecialMission }) =>
      mode === MissionMode.TodayActive &&
      !isSpecialMission &&
      css`
        &::before {
          content: '';
          position: absolute;
          width: 15px;
          height: 15px;
          top: 55%;
          left: 50%;
          transform: translate(-50%, -50%);
          animation: ${light} 1.3s infinite alternate;
          opacity: 0.4;
          background: #ffecd5;
          filter: blur(4px);
          border-radius: 100%;
          z-index: 5;
        }
      `};
  }
`;

const glow = keyframes`
  0% {
      filter: drop-shadow(0 0 3px #ffecd5);
    }
    100% {
      filter: drop-shadow(0 0 3px transparent);
    }
`;

const light = keyframes`
  0% {
      width: 15px;
      height: 15px;
    }
    100% {
      width: 30px;
      height: 30px;
    }
`;
